document.documentElement.classList.remove('no-js');

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  var select = event.target;
  var price = select.options[select.selectedIndex].getAttribute('data-price');
  var compare = select.options[select.selectedIndex].getAttribute('data-compare');
  var priceTarget = document.querySelector('[data-product-price]');
  var compareTarget = document.querySelector('[data-product-compare]');
  var variantInput = document.querySelector('[data-product-id]');
  if (priceTarget && price) priceTarget.textContent = price;
  if (compareTarget) {
    compareTarget.textContent = compare || '';
    compareTarget.hidden = !compare;
  }
  if (variantInput) variantInput.value = select.value;
});
